var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutorNoPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_executor_no_photo)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#DAD1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.9999C11.515 9.9999 12.7429 8.74647 12.7429 7.1999C12.7429 5.65334 11.515 4.3999 10 4.3999C8.48501 4.3999 7.25716 5.65334 7.25716 7.1999C7.25716 8.74647 8.48501 9.9999 10 9.9999ZM11.92 10.6999H11.5622C11.0864 10.923 10.5572 11.0499 10 11.0499C9.44287 11.0499 8.91573 10.923 8.43787 10.6999H8.08001C6.49001 10.6999 5.20001 12.0168 5.20001 13.6399V14.5499C5.20001 15.1296 5.66073 15.5999 6.22858 15.5999H13.7714C14.3393 15.5999 14.8 15.1296 14.8 14.5499V13.6399C14.8 12.0168 13.51 10.6999 11.92 10.6999Z",
    fill: "#BBB0A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_executor_no_photo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutorNoPhotoIcon);
export default __webpack_public_path__ + "static/media/executor-no-photo-icon.132fb4cbe5ba0ca12bf3be846f9bc669.svg";
export { ForwardRef as ReactComponent };